import { render, staticRenderFns } from "./view_participant_type.vue?vue&type=template&id=519f9e04&"
import script from "./view_participant_type.vue?vue&type=script&lang=js&"
export * from "./view_participant_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519f9e04')) {
      api.createRecord('519f9e04', component.options)
    } else {
      api.reload('519f9e04', component.options)
    }
    module.hot.accept("./view_participant_type.vue?vue&type=template&id=519f9e04&", function () {
      api.rerender('519f9e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/view_participant_type.vue"
export default component.exports